/**
 * Created by rickborst on 31/07/2017.
 */

const DeviceTypes = {
        TV: 'tv',
        DESKTOP: 'desktop',
        TABLET: 'tablet',
        MOBILE: 'mobile',
        UNKNOWN: 'unknown'
    },

    Errors = {
        UNKNOWN: 'UNKNOWN',
        DEVICE_LIMIT_REACHED: 'DEVICE_LIMIT_REACHED',
        DEVICE_IN_ANOTHER_HOUSEHOLD: 'DEVICE_IN_ANOTHER_HOUSEHOLD'
    };

class Device {

    /**
     * Constructs the object.
     *
     * @param {Object} data - Device data.
     */
    constructor (data = {}) {

        this.udid = data.udid || '';
        this.name = data.name || '';
        this.type = data.type || DeviceTypes.UNKNOWN;
        this.householdId = data.householdId || 0;
        this.activationDate = data.activationDate || null;
        this.apiSpecifics = data.apiSpecifics || {};
    }
}

export default Device;
export {
    DeviceTypes,
    Errors
};


// WEBPACK FOOTER //
// ./src/js/models/device.js